module.exports = __webpack_public_path__ + "img/ico-us_BIG.54783611.png";